export const GET_META_DATA = 'refinance/GET_META_DATA';
export const VEHICLE_DETAIL_FORM = 'refinance/VEHICLE_DETAIL_FORM';
export const MORE_PERSONAL_INFO= 'refinance/MORE_PERSONAL_INFO';
export const LOAN_DETAIL= 'refinance/LOAN_DETAIL';
export const VEHICLE_DATA= 'refinance/VEHICLE_DATA';
export const APPLICATION_CAR_DATA= 'refinance/APPLICATION_CAR_DATA';
export const LOAN_TYPE= 'refinance/LOAN_TYPE';
export const PRICE_FIELD = 'refinance/PRICE_FIELD';
export const USED_CAR_NEW_CAR = 'refinance/USED_CAR_NEW_CAR';
export const LOAN_FORM_DETAILS= 'refinance/LOAN_FORM_DETAILS';
export const LOAN_REQUESTED_AMOUNT= 'refinance/LOAN_REQUESTED_AMOUNT';
export const NEW_FLOW_ACTIVE = 'refinance/NEW_FLOW_ACTIVE'
